<template>
  <div class="home homeHlgj">
    <!-- banner -->
    <home-banner ref="homeBanner" :height="516"></home-banner>

    <div class="mian mainHome">
      <div class="wrap">
        <!-- 热点新闻 -->
        <div class="home_pre homePreHlgj clearfloat">
          <div class="home_pre_l fl">
            <!-- <div class="homeTopNewTitle">热点新闻</div> -->
            <img src="../assets/img/new_top.png" alt="">
          </div>
          <div class="inner">
            <el-carousel height="154px" :interval="2500" indicator-position="none">
              <el-carousel-item v-for="item in newsTop" :key="item.entTArticleUuid">
                <div class="homeTopInner">
                  <h3 class="single-line">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{item.title}}</a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{item.title}}</a>
                  </h3>
                  <h4 class="single-line">
                    <a :href="item.url && item.url !== '' ? item.url : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{item.ftitle}}</a>
                  </h4>
                  <p>
                    {{item.artDesc | ellipsisTop}}
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">查看详情</a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">查看详情</a>
                  </p>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="homeHlgjTitle">
          <img src="../assets/img/news_center_title.png" alt="">
        </div>
        <!-- 新闻中心 -->
        <div class="homeNews" style="padding-bottom: 60px;">
          <el-row :gutter="40">
            <el-col :span="12">
              <div class="homeNannerBox" v-if="activeNewsHd == 0">
                <div class="swiper-container bannerHomeSec01" id="bannerHomeSec01">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in newsLeft01" :key="index">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                        <img :src="item.thumb1" alt="">
                        <p class="single-line">{{item.title}}</p>
                      </a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                        <img :src="item.thumb1" alt="">
                        <p class="single-line">{{item.title}}</p>
                      </a>
                    </div>
                  </div>
                  <div class="swiper-pagination swiper-pagination-sec01"></div>
                  <div class="swiper-button-prev swiper-button-prev-sec01"></div>
                  <div class="swiper-button-next swiper-button-next-sec01"></div>
                </div>
              </div>
              <div class="homeNannerBox" v-if="activeNewsHd == 1">
                <div class="swiper-container bannerHomeSec01" id="bannerHomeSec02">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in newsLeft02" :key="index">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                        <img :src="item.thumb1" alt="">
                        <p class="single-line">{{item.title}}</p>
                      </a>
                      <a v-else target="_blank" :href="`/detail/01060001/${item.entTArticleUuid}`">
                        <img :src="item.thumb1" alt="">
                        <p class="single-line">{{item.title}}</p>
                      </a>
                    </div>
                  </div>
                  <div class="swiper-pagination swiper-pagination-sec01"></div>
                  <div class="swiper-button-prev swiper-button-prev-sec01"></div>
                  <div class="swiper-button-next swiper-button-next-sec01"></div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="homeNewsBox">
                <div class="homeNewsHd">
                  <span class="homeNewsHdInner" :class="{active : activeNewsHd == index}" v-for="(item, index) in newsHdList" :key="index + 'dec01'" @mouseenter="mouseenterNewsHd(index)">
                    <a :href="item.url" target="_balnk">{{ item.title }}</a>
                  </span>
                </div>
                <ul class="news_list newsListHlgj01" v-if="activeNewsHd == 0">
                  <li v-for="(item,index) in newsRight01" :key="index" >
                    <div class="news_list_time fr">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                    <p class="news_list_inner single-line">
                      <a target="_blank" :href="item.url && item.url !== '' ? item.url : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{item.title}}</a>
                    </p>
                    <div class="listTxt multi-line" v-if="index == 0">
                      {{item.artDesc}}
                    </div>
                  </li>
                </ul>
                <ul class="news_list newsListHlgj01" v-if="activeNewsHd == 1">
                  <li v-for="(item,index) in newsRight02" :key="index" >
                    <div class="news_list_time fr">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                    <p class="news_list_inner single-line">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{item.title}}</a>
                      <a v-else target="_blank" :href="`/detail/01060001/${item.entTArticleUuid}`">{{item.title}}</a>
                    </p>
                    <div class="listTxt multi-line" v-if="index == 0">
                      {{item.artDesc}}
                    </div>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 企业简介 -->
      <div class="companyDec">
        <div class="wrap">
          <div class="homeHlgjTitle">
            <img src="../assets/img/company_about_title.png" alt="">
          </div>
          <div class="companyDecBox">
            <el-row :gutter="20">
              <el-col :span="10">
                <div class="companyDecRight">
                  <img src="../assets/img/about_thumb.png" alt="">
                </div>
              </el-col>
              <el-col :span="14">
                <div class="homeHlgjBrief">
                  <el-row :gutter="40">
                    <el-col :span="12">
                      <div class="homeHlgjBriefTop homeHlgjBriefTop01">
                        <a class="clearfloat" href="listPage/01020001" target="_blank">
                          <div class="fl ico trans"></div>
                          <div class="inner">
                            公司概况
                          </div>
                        </a>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="homeHlgjBriefTop homeHlgjBriefTop02">
                        <a class="clearfloat" href="/list/0111" target="_blank">
                          <div class="fl ico trans"></div>
                          <div class="inner">
                            公示公告
                          </div>
                        </a>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="homeHlgjBriefTop homeHlgjBriefTop03">
                        <a class="clearfloat" href="/listPage/01020004" target="_blank">
                          <div class="fl ico trans"></div>
                          <div class="inner">
                            组织架构
                          </div>
                        </a>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="homeHlgjBriefTop homeHlgjBriefTop04">
                        <a class="clearfloat" href="/listPic/01020005" target="_blank">
                          <div class="fl ico trans"></div>
                          <div class="inner">
                            公司荣誉
                          </div>
                        </a>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="homeHlgjBriefTxt">
                    <p>
                      华陇国际产业投资有限公司（简称“华陇投资公司”）成立于2019年3月26日，是由甘肃省建设投资(控股)集团公司（简称“甘肃建投”）设立的国有独资公司，注册资本22.69亿元。甘肃建投自2019年9月被列为甘肃省国有资本投资公司试点企业，华陇投资公司是甘肃建投唯一的产业投资公司，并确定为甘肃建投投融资平台。公司主要经营范... 
                    </p>
                  </div>
                  <div class="homeHlgjBriefMore">
                    <a href="listPage/01020001" target="_blank">点击详情>></a>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 党建 -->
      <div class="cultureDec" style="padding-top: 60px;">
        <div class="wrap">
          <div class="homeHlgjTitle">
            <img src="../assets/img/party_title.png" alt="">
          </div>
          <div class="cultureBox">
            <div class="cultureWrap">
              <el-row :gutter="30">
                <el-col :span="12">
                  <div class="homeNewsHd">
                    <span class="homeNewsHdInner" :class="{active : activeNewsHdCulture == index}" v-for="(item, index) in newsHdCultureList" :key="index + 'dec05'" @mouseenter="mouseenterNewsHdCulture(index)">
                      <a :href="item.url" target="_balnk">{{ item.title }}</a>
                    </span>
                  </div>
                  <div class="homeNewsBox">
                    <ul class="news_list" v-if="activeNewsHdCulture == 0">
                      <div class="homeNewsHlgjListTop clearfloat">
                        <div class="fl time">
                          <div class="date">
                            {{ dayjs(cultureImg01.publishDate).format('DD') }}
                          </div>
                          <div class="year">
                            <span>{{ dayjs(cultureImg01.publishDate).format('MM') }}</span>
                            <span>{{ dayjs(cultureImg01.publishDate).format('YYYY') }}</span>
                          </div>
                        </div>
                        <div class="inner">
                          <h3 class="single-line">
                            <a :href="cultureImg01.url && cultureImg01.url !== '' ? cultureImg01.url : `/detail/${cultureImg01.entTChannelUuid}/${cultureImg01.entTArticleUuid}`" target="_blank">{{cultureImg01.title}}</a>
                          </h3>
                          <p class="multi-line">
                            {{cultureImg01.artDesc}}
                          </p>
                        </div>
                      </div>
                      <li v-for="(item,index) in cultureList01" :key="index" >
                        <div class="news_list_time fr">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                        <p class="news_list_inner single-line">
                          <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{item.title}}</a>
                          <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{item.title}}</a>
                        </p>
                      </li>
                    </ul>
                    <ul class="news_list" v-if="activeNewsHdCulture == 1">
                      <div class="homeNewsHlgjListTop clearfloat">
                        <div class="fl time">
                          <div class="date">
                            {{ dayjs(cultureImg02.publishDate).format('DD') }}
                          </div>
                          <div class="year">
                            <span>{{ dayjs(cultureImg02.publishDate).format('MM') }}</span>
                            <span>{{ dayjs(cultureImg02.publishDate).format('YYYY') }}</span>
                          </div>
                        </div>
                        <div class="inner">
                          <h3 class="single-line">
                            <a :href="cultureImg02.url && cultureImg02.url !== '' ? cultureImg02.url : `/detail/${cultureImg02.entTChannelUuid}/${cultureImg02.entTArticleUuid}`" target="_blank">{{cultureImg02.title}}</a>
                          </h3>
                          <p class="multi-line">
                            {{cultureImg02.artDesc}}
                          </p>
                        </div>
                      </div>
                      <li v-for="(item,index) in cultureList02" :key="index" >
                        <div class="news_list_time fr">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                        <p class="news_list_inner single-line">
                          <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{item.title}}</a>
                          <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{item.title}}</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="homeHlgjJb">
                    <a href="/report/0112" target="_balnk">
                      <img class="trans" src="../assets/img/jcjb.jpg" alt="">
                    </a>
                  </div>
                  <div class="homeNewsHd">
                    <span class="homeNewsHdInner active">
                      <a href="/list/0108" target="_balnk">企业文化</a>
                    </span>
                  </div>
                  <div class="homeNewsBox">
                    <ul class="news_list">
                      <li v-for="(item,index) in cultureList03" :key="index" >
                        <div class="news_list_time fr">{{ dayjs(item.publishDate).format('MM-DD') }}</div>
                        <p class="news_list_inner single-line">
                          <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{item.title}}</a>
                          <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{item.title}}</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>

      <!-- 友情链接 -->
      <div class="linkBox">
        <div class="wrap">
          <el-row :gutter="50">
            <el-col :span="6">
              <el-select v-model="linkValue01" placeholder="请选择" size="small" style="width: 100%;" @change="changeLink01">
                <el-option
                  v-for="(item, index) in linkList01"
                  :key="index"
                  :label="item.name"
                  :value="item.httpUrl">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="linkValue02" placeholder="请选择" size="small" style="width: 100%;" @change="changeLink02">
                <el-option
                  v-for="(item, index) in linkList02"
                  :key="index"
                  :label="item.title"
                  :value="item.url">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="linkValue03" placeholder="请选择" size="small" style="width: 100%;" @change="changeLink03">
                <el-option
                  v-for="(item, index) in linkList03"
                  :key="index"
                  :label="item.title"
                  :value="item.url">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="linkValue04" placeholder="请选择" size="small" style="width: 100%;" @change="changeLink04">
                <el-option
                  v-for="(item, index) in linkList04"
                  :key="index"
                  :label="item.title"
                  :value="item.url">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <window-box ref="windowBox"></window-box>   
  </div>
</template>
<script>
import Swiper from "swiper"
import windowBox from '@/components/windowBox/index.vue'
import homeBanner from "@/components/banner/bannerFade.vue"
import { getTopArtList, picArticles, articles, getApplicationList } from '@/api/common'
export default {
  components: {
    homeBanner,
    windowBox
  },
  name: 'home',
  data(){
    return {
      activeNewsHd: 0,
      activeNewsHdCase: 0,
      activeNewsHdCulture: 0,
      newsHdList: [
        {
          title: '公司新闻',
          url: '/list/01060002'
        },
        {
          title: '集团要闻',
          url: '/list/01060001'
        }
      ],
      newsHdCaseList: [
        {
          title: '业绩展示',
          url: '/list/00350001'
        },
        {
          title: '在线工程',
          url: '/list/00350003'
        }
      ],
      newsHdCultureList: [
        {
          title: '党建工作',
          url: '/list/01070001'
        },
        {
          title: '专题专栏',
          url: '/list/01070002'
        }
      ],
      activeNewsHdDes02: 0,
      newsHdListDes02: [
        {
          title: '学习教育',
          url: '/list/0076'
        },
        {
          title: '行业动态',
          url: '/list/00700002'
        }
      ],
      newsTop: [],
      newsLeft: [
        {
          title: '省旅投集团举办首期抖音短视频省旅投集团举办首期抖音短视频省旅投集团举办首期抖音短视频',
          thumb1: require('../assets/img/home_vedio_img01.jpg'),
          time: '2021-02-03',
          id: '1',
        }
      ],
      newsRight: [
        {
          title: '集团公司领导赴焉支山景区调研指导工作',
          img: require('../assets/img/home_vedio_img01.jpg'),
          id: '1',
          cont: '9月15日，集团公司副总经理孙进玲一行赴焉支山景区调研指导工作，旅投集团负责人陪同调研旅投集团负责人陪同调研旅投集团负责人陪同调研。  孙进玲副总经理实地查看了焉支山景区',
          publishDate: '2021-05-14'
        }
      ],
      newsLeft01: [],
      newsLeft02: [],
      newsLeft03: [],
      newsRight01: [],
      newsRight02: [],
      newsRight03: [],
      homeNoticeList: [],
      homeDec02Url: '',
      homeDec02ImgUrl: '',
      homeNewsPeriodicalList: [],
      homeNewsBasicTop: {
        title: '省旅投集团举办首期抖音短视频省旅投集团举办首期抖音短视频省旅投集团举办首期抖音短视频',
        thumb1: require('../assets/img/home_vedio_img01.jpg'),
        time: '2021-02-15',
        id: '1',
        artDesc: '省旅投集团举办首期抖音短视频省旅投集团举办首期抖音短视频省旅投集团举办首期抖音短视频省旅投集团举办首期抖音短视频省旅投集团举办首期抖音短视频省旅投集团举办首期抖音短视频'
      },
      newsNotice: [],
      homeNewsBasicList: [],
      homeNewsTopDj: {},
      homeNewsTopXxjy: {},
      homeNewsTopHydt: {},
      homeNewsDjList: [],
      homeNewsXxjyList: [],
      homeNewsHydtList: [],
      pointImgList: [],
      specailList: [],
      newsNotice01: [],
      newsNotice02: [],
      homeNewsBasicTop01: {},
      homeNewsBasicTop02: {},
      homeNewsBasicList01: [],
      homeNewsBasicList02: [],
      caseList01: [],
      caseList02: [],
      cultureImg01: {},
      cultureImg02: {},
      cultureImg03: {},
      cultureImg04: {},
      cultureList01: [],
      cultureList02: [],
      cultureList03: [],
      cultureList04: [],
      linkValue01: ' ----内部链接---- ',
      linkValue02: ' ----友情链接---- ',
      linkValue03: ' ----行业链接---- ',
      linkValue04: ' ----媒体链接---- ',
      linkList01: [
        {
          name: '甘肃省建设投资（控股）集团总公司 ',
          httpUrl: 'http://www.gsjtw.cc'
        }
      ],
      linkList02: [
        {
          title: '谷歌 ',
          url: 'http://www.google.com'
        },
        {
          title: '中国咨询频道 ',
          url: 'http://www.cccv.cn/'
        },
        {
          title: '新浪 ',
          url: 'http://www.sina.com.cn'
        },
        {
          title: '搜狐 ',
          url: 'http://www.sohu.com'
        },
        {
          title: '人民网 ',
          url: 'http://www.people.com.cn/'
        },
        {
          title: '百度 ',
          url: 'http://www.baidu.com'
        },
        {
          title: '雅虎 ',
          url: 'http://www.yahoo.com.cn'
        },
        {
          title: '新华网 ',
          url: 'http://www.xinhuanet.com/'
        },
        {
          title: '网易 ',
          url: 'http://www.163.com'
        },
      ],
      linkList03: [
        {
          title: '中国建造师网 ',
          url: 'http://www.coc.gov.cn/'
        },
        {
          title: '中华人民共和国住房和城乡建设部 ',
          url: 'http://www.mohurd.gov.cn/'
        },
        {
          title: '甘肃经济信息网 ',
          url: 'http://www.gsei.com.cn/'
        },
        {
          title: '甘肃省住房和城乡建设厅 ',
          url: 'http://www.gsjs.gansu.gov.cn/'
        },
      ],
      linkList04: [],
    }
  },
  mounted(){
    this.getTopArtList()
    this.homeNewsCompany()
    this.bannerHomeSec01()
    this.cultureList()
    this.getApplicationList()
  },
  filters: {
    //超过100位显示 ...
    ellipsisTop: function(value) {
      if (!value) return ''
      if (value.length > 100) {
        return value.slice(0, 100) + '...'
      }
      return value
    },
    ellipsis: function(value) {
      if (!value) return ''
      if (value.length > 54) {
        return value.slice(0, 54) + '...'
      }
      return value
    },
  },
  methods: {
    // 内部链接
    getApplicationList() {
      var _this = this
      getApplicationList().then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.linkList01 = [
            {
              name: '甘肃省建设投资（控股）集团总公司 ',
              httpUrl: 'http://www.gsjtw.cc'
            },
            ...data
          ]
        }
      })
    },
    // 头条
    getTopArtList() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getTopArtList(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsTop = data
        }
      })
    },
    // 集团要闻/建投新闻/党的建设
    homeNewsCompany() {
      var _this = this

      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01060002',
        pageNum: 1,
        pageSize: 8
      }
      articles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight01 = data.rows
        }
      })

      let data02 = {
        entTApplicationUuid: _this.webIdGroup,
        // channelUuid: '01060001',
        channelUuid: '00190001',
        pageNum: 1,
        pageSize: 8
      }
      articles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight02 = data.rows
        }
      })
    },
    mouseenterPeriodical(val) {
      var _this = this

      _this.homeDec02ImgUrl = val.thumb1
      _this.homeDec02Url = val.url
    },
    mouseenterNewsHd(val) {
      var _this = this

      _this.activeNewsHd = val
    },
    mouseenterNewsHdCase(val) {
      var _this = this

      _this.activeNewsHdCase = val
    },
    mouseenterNewsHdCulture(val) {
      var _this = this
      _this.activeNewsHdCulture = val
    },
    mouseenterNewsHdDes02(val) {
      var _this = this

      _this.activeNewsHdDes02 = val
    },
    // 焦点图
    bannerHomeSec01(){
      var _this = this

      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01060002',
        pageNum: 1,
        pageSize: 6
      }
      picArticles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsLeft01 = data.rows
          this.$nextTick(() => {
            new Swiper("#bannerHomeSec01", {
              effect : 'fade',
              fade: {
                crossFade: false,
              },
              speed: 300,
              autoplay: 4000,
              loop: true,
              observeSlideChildren: true,
              prevButton:'.swiper-button-prev-sec01',
              nextButton:'.swiper-button-next-sec01', 

              paginationClickable: true,
              pagination: '.swiper-pagination-sec01',
              paginationType: 'fraction',
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false,   //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })

      let data02 = {
        // channelUuid: '01060001',
        entTApplicationUuid: _this.webId,
        channelUuid: '00190001',
        pageNum: 1,
        pageSize: 6
      }
      picArticles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsLeft02 = data.rows
          this.$nextTick(() => {
            new Swiper("#bannerHomeSec02", {
              effect : 'fade',
              fade: {
                crossFade: false,
              },
              speed: 300,
              autoplay: 4000,
              loop: true,
              observeSlideChildren: true,
              prevButton:'.swiper-button-prev-sec01',
              nextButton:'.swiper-button-next-sec01', 
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false,   //用户操作swiper之后重新启动autoplay
              paginationClickable :true,
              pagination : '.swiper-pagination-sec01',
              paginationType : 'fraction',
            })
          })
        }
      })
    },
    // 企业文化
    cultureList() {
      var _this = this

      let dataList01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01070001',
        pageNum: 1,
        pageSize: 8
      }
      articles(dataList01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          if (data.rows.length) {
            _this.cultureImg01 = data.rows[0]
            _this.cultureList01 = data.rows.slice(1, 9)
          }
        }
      })
      
      let dataList02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01070002',
        pageNum: 1,
        pageSize: 8
      }
      articles(dataList02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          if (data.rows.length) {
            _this.cultureImg02 = data.rows[0]
            _this.cultureList02 = data.rows.slice(1, 9)
          }
        }
      })

      let dataList03 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0108',
        pageNum: 1,
        pageSize: 4
      }
      articles(dataList03).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.cultureList03 = data.rows
        }
      })
    },
    // 友情链接
    changeLink01(val) {
      window.open(val)
    },
    changeLink02(val) {
      window.open(val)
    },
    changeLink03(val) {
      window.open(val)
    },
    changeLink04(val) {
      window.open(val)
    },
  }
}
</script>
<style scoped>
.bannerHome {
  height: 620px;
  position: relative;
}
.bannerHome .swiper-wrapper,
.bannerHome .swiper-slide,
.bannerHome img {
  height: 100%;
}
.bannerHome img {
  width: 100%;
}
.swiper-pagination-banner {
  color: #fff;
  font-size: 16px;
}
.swiper-pagination-current {
  font-size: 20px;
}
.bannerHomeSec01 .swiper-wrapper,
.bannerHomeSec01 .swiper-slide,
.bannerHomeSec01 img {
  height: 100%;
}
.bannerHomeSec01 img {
  width: 100%;
  height: 100%;
}
.bannerHomeSec01 .swiper-slide {
  position: relative;
}
/* .bannerHomeSec01 p {
  position: absolute;
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 118px 0 12px;
  left: 0;
  bottom: 0;
  color: #fff;
  font-size: 16px;
  background-color: rgba(0,0,0,0.8);
  box-sizing: border-box;
  text-align: left;
} */
.bannerHomeSec01 .swiper-pagination-bullet {
  width: 44px;
  height: 44px;
  text-align: center;
  border-radius: 0;
  background-color:rgba(0, 0, 0, 0.2);
  opacity: 1;
}
.bannerHomeSec01 .swiper-pagination-bullet-active {
  background-color:#CE251F;
}
.bannerHomeSec01 .swiper-pagination .swiper-pagination-current {
  font-size: 30px;
}
/* 友情链接 */
.sec_zfgs_list a {
    display: block;
    text-align: center;
    line-height: 34px;
    border: 1px solid #d5d5d5;
    margin-bottom: 6px;
}

.sec_zfgs_list a:hover {
    border-color: #2b78c6;
    color: #fff;
    background-color: #2b78c6;
}
.homeNotice {
  height: 60px;
  line-height: 60px;
  background-color: #F3F3F3;
  margin: 30px 0;
  padding: 0 35px;
  text-align: center;
}
.homeNoticeL {
  width: 57px;
  height: 28px;
  overflow: hidden;
  border: solid 1px #0D65AC;
  line-height: 28px;
  margin: 17px 0px 0px 0;
  box-sizing: border-box;
}
.homeNoticeBox {
  margin-left: 88px;
  height: 100%;
}
.bannerHomeNotice a {
  font-size: 18px;
}
.bannerHomeNotice a:hover {
  color: #0D65AC;
}
.bannerHomeNotice .swiper-slide{
  width: 300px;
  width: auto;
}
#bannerHomeNotice>.swiper-wrapper {
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
.homeDec02 {
  margin-bottom: 40px;
}
.homeDec02Img {
  height: 310px;
  overflow: hidden;
  margin-bottom: 15px;
  /* padding: 7px 8px; */
  /* border: solid 1px #D9D2C2; */
}
.homeDec02Img img,
.homeDec02BottomImg img {
  width: 100%;
  height: 100%;
  -moz-transition: all 0.3s ease-in;
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}
.homeDec02Img img:hover,
.homeDec02BottomImg img:hover {
  -moz-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -o-transform: scale(1.1);
  transform: scale(1.1);
}
.homeDec02BottomImg {
  height: 171px;
  overflow: hidden;
}
.homeDec02Bottom {
  margin-top: 30px;
}
.homeNewsBasicTop p a:hover {
  text-decoration: underline;
}
.homeDec03 {
  margin-top: 30px;
}
.homeTopNewTitle {
  width: 62px;
  height: 62px;
  background-color: #017bce;
  padding: 10px;
  color: #FFFFFF;
  font-size: 18px;
  letter-spacing: 2px;
  line-height: 20px;
  text-align: center;
  font-weight: bold;
  margin-top: 15px;
  float: left;
  box-sizing: border-box;
}
</style>